import * as fe from "@runn/filter-engine"
import React from "react"
import { graphql, useLazyLoadQuery } from "react-relay"

import type { PlannerFilterQueryQuery } from "./__generated__/PlannerFilterQueryQuery.graphql"

import { getView, getViewLogic } from "~/Views/helpers"

import FilterQuery from "~/Planner/FilteredQuery/FilterQuery"
import FilteredPlannerProvider from "~/Planner/FilteredQuery/FilteredPlannerProvider"
import { ViewsProvider } from "~/Views/ViewsProvider"

type Props = {
  children: React.ReactNode
}

const QUERY = graphql`
  query PlannerFilterQueryQuery {
    ...ViewsProvider_gql
    allViews: availableViews {
      ... on AvailableViewInterface {
        projectFilters
        peopleFilters
      }
      ... on DatabaseView {
        id
        databaseId
      }
      ... on VirtualView {
        id
        alias
      }
    }
    selectedView {
      ... on SelectedDatabaseView {
        type
        databaseId
        isCoerced
      }
      ... on SelectedVirtualView {
        alias
        isCoerced
      }
    }
  }
`

const PlannerFilterQuery = (props: Props) => {
  const data = useLazyLoadQuery<PlannerFilterQueryQuery>(QUERY, {})
  const { selectedView, allViews } = data

  const view = getView(allViews, selectedView)
  const projectFilters = view ? fe.filters.flat(view.projectFilters) : []
  const peopleFilters = view ? fe.filters.flat(view.peopleFilters) : []

  if (!selectedView || selectedView.isCoerced) {
    return (
      <ViewsProvider gql={data}>
        <FilteredPlannerProvider
          projectIDs={[-1]}
          peopleIDs={[-1]}
          totalProjectCount={0}
          totalPeopleCount={0}
        >
          {props.children}
        </FilteredPlannerProvider>
      </ViewsProvider>
    )
  }
  return (
    <ViewsProvider gql={data}>
      <FilterQuery
        peopleFilters={peopleFilters}
        projectFilters={projectFilters}
        logic={getViewLogic(view)}
      >
        {props.children}
      </FilterQuery>
    </ViewsProvider>
  )
}

export default PlannerFilterQuery
